import { Component } from '@angular/core';

@Component({
  selector: 'app-plus-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './plus-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class PlusIconComponent {}
